// extracted by mini-css-extract-plugin
module.exports = {"relative":"TransferHistory_relative_1T_-l","container":"TransferHistory_container_1ZyXr","paginatorContainer":"TransferHistory_paginatorContainer_XaQuP"};